import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-2" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-type-3-bold" }, "Highlights", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(_ctx.content), 1)
    ])
  ]))
}